<template>
    <div class="admin1 col-md-3" style="margin: 0 auto; top: 30%;">
        <div
            style="text-align: center;border: 1px solid rgba(0, 0, 0, 0.125); background-color: rgba(0, 0, 0, 0.03); padding:10px 0;">
            管理者</div>
        <ul class="nav nav-tabs">
            <li class="active"><a data-toggle="tab" href="#home">登入</a></li>
            <li><a data-toggle="tab" href="#menu1">註冊</a></li>
        </ul>
        <div class="tab-content">
            <div id="home" class="tab-pane fade show active">
                <form style="padding: 20px; background-color:#fff;border: 1px solid rgba(0, 0, 0, 0.125);"
                    v-on:submit.prevent="userlogin">
                    <div class="form-group">
                        <label for="exampleInputtext1">帳號</label>
                        <input type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp"
                            placeholder="請輸入帳號" required="required" v-model="username">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">密碼</label>
                        <input type="password" class="form-control" id="exampleInputPassword0" placeholder="請輸入密碼"
                            required="required" v-model="password">
                    </div>
                    <div id="error-passwd"></div>
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="gridCheck">
                            <label class="form-check-label" for="gridCheck">
                                記住我
                            </label>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-lg btn-block">登入</button>
                </form>
            </div>
            <div id="menu1" class="tab-pane fade">
                <form style="padding: 20px; background-color:#fff;border: 1px solid rgba(0, 0, 0, 0.125);"
                    v-on:submit.prevent="userregister">
                    <div class="form-group">
                        <label for="">名字</label>
                        <input type="name" class="form-control" id="exampleInputname" aria-describedby="emailHelp"
                            placeholder="請輸入名字" required="required" v-model="name">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputtext">帳號</label>
                        <input type="text1" class="form-control" id="exampleInputemail" aria-describedby="emailHelp"
                            placeholder="請輸入帳號" required="required" v-model="username">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">密碼</label>
                        <input type="password" class="form-control" id="exampleInputPassword" placeholder="請輸入密碼"
                            required="required" v-model="password">
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">密碼確認</label>
                        <input type="password" class="form-control" id="exampleInputPassword1" placeholder="再輸入一次密碼"
                            required="required" v-model="password_confirmation">
                        <div class="text-danger" v-if="this.password_equal">密碼錯誤</div>
                    </div>

                    <button type="submit" class="btn btn-primary"
                        style="margin: 0 auto; display: flex; padding: 10px 60px;">註冊</button>
                </form>
            </div>

        </div>
    </div>


</template>

<script>
    export default {
        props: ['nextPage'],
        data() {
            return {
                name: '',
                username: '',
                password: '',
                password_confirmation: '',
            }
        },
        computed: {
            password_equal() {
                return this.password !== this.password_confirmation;
            }
        },
        methods: {
            userregister: function() {
                axios
                    .post(base_url + '/admin/api/register', {
                        name: this.name,
                        username: this.username,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                    })
                    .then((response) => {
                        if (response.data.message == "register and login successed.") {
                            alert('註冊成功');
                            Turbolinks.visit(this.nextPage);
                        }
                        console.log(response);
                    })
                    .catch(function(error) {
                        if (error.response.data.errors.username == "The username has already been taken.") {
                            alert('帳號已註冊');
                        } else if (error.response.data.errors.password == "The password must be at least 8 characters.") {
                            alert('密碼需8位數')
                        }
                    });
            },
            userlogin: function() {
                let component = this;
                axios
                    .post(base_url + '/admin/api/login', {
                        username: this.username,
                        password: this.password,
                    })
                    .then((response) => {
                        if (response.data.message == "Login success.") {
                            Turbolinks.visit(component.nextPage);
                        }
                    })
                    .catch(function(error) {
                        console.log(error.response.data.message);
                        if (error.response.data.message == "The given data was invalid.") {
                            alert('帳號密碼錯誤');
                        }
                    });
            },
            logOut: function() {
                axios
                    .post(base_url + '/admin/api/logout')
                    .then((response) => {
                        console.log(response.data);
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        }
    }
</script>
<style scoped>
    .admin1 ul {
        text-align: center;
        border: 1px solid rgba(0, 0, 0, 0.125);
        background-color: rgba(0, 0, 0, 0.03);
        padding: 10px 0;
        margin-top: 0;
        justify-content: space-around;
    }
</style>